module.exports = __webpack_public_path__ + "media/images/riders/small/FLORIAN_VOGEL-7242c03bdf63f52aa31b2457ede8e89a.png";